module.exports = __webpack_public_path__ + "media/images/how-it-works/arena/step-1-778b46ea693eee59544c26f56f5f7fd0.png";